import(/* webpackMode: "eager" */ "/home/ubuntu/user-b2c/node_modules/next/dist/client/image-component.js")